
import axios from "axios";

const api = axios.create({
    baseURL: 'https://integraciones-labs.titask.com/api/integrations/v1/',
    headers: {
        "Accept": 'application/json',
        "Content-type": "application/json; charset=utf-8",
        "Access-Control-Allow-Origin": "*",
        "Authorization": "R4qLIFZLICafC4WQzEwLhBNUvKO",
        "country": "CL",
        "lang": "es"
    },
})

const api2 = axios.create({
    baseURL: 'https://integraciones-labs.titask.com/api/integrations/v1/',
    headers: {
        "Accept": 'application/json',
        "Content-type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "Authorization": "R4qLIFZLICafC4WQzEwLhBNUvKO",
        "country": "CL",
        "lang": "es"
    },
})

const SearchFiles = {

    findBlackList: async (body: any) => {
        try {
            const response = await api.get(`buk/blackList`, body);
            const userData = response.data.data;
            return {
                success: true,
                data: userData
            }
        } catch (err: any) {
            return {
                success: false,
                error: err?.response?.data
            }
        }
    },

    deleteBlackList: async (body: any) => {
        try {
            console.log(body)
            const response = await api.post(`buk/blackListD`, body);
            const userData = response.data;
            return {
                success: true,
                data: userData,
                userId: response.data
            }
        } catch (err: any) {
            return {
                success: false,
                error: err?.response?.data
            }
        }
    },

    saveBlackList: async (body: any) => {
        try {
            console.log(body)
            const response = await api.post(`buk/blackList`, body);
            const userData = response.data;
            return {
                success: true,
                data: userData,
                userId: response.data
            }
        } catch (err: any) {
            return {
                success: false,
                error: err?.response?.data
            }
        }
    },

    uploadFile: async (idUser: any, data: any) => {
        try {
            const response = await api2.post(`buk/employe/files-up/${idUser}`, data);
            const userData = response.data;
            return {
                success: true,
                data: userData,
                userId: response.data
            }
        } catch (err: any) {
            return {
                success: false,
                error: err?.response?.data
            }
        }
    },

};

export default SearchFiles;